import React, { useEffect, useState } from "react";
import { boolean } from "yup";
import { toast } from "react-toastify";
import { Badge } from "react-bootstrap";
import { Modal, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Link } from "react-scroll";
import {
  getOrder_GetAll_FilterList,
  GetProductList_ByOrderIDAPI,
} from "../CustomerCRUD";
import MemberHeader from "../ramnambook-registration/member-dasboard/MemberHeader";

const statusConfig = {
  Delivered: { bg: "#fff3ee", color: "#FF4F00", dot: "#FF4F00" },
  Processing: { bg: "#fff8e6", color: "#b45309", dot: "#f59e0b" },
  Shipped: { bg: "#eff6ff", color: "#1d4ed8", dot: "#3b82f6" },
  Cancelled: { bg: "#fef2f2", color: "#b91c1c", dot: "#ef4444" },
};

export default function OrderHistory() {
  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [filterStatus, setFilterStatus] = useState("All");
  const [orderData, setOrderData] = useState([]);
  const [isLoggedIn, setIsLoggedIn] = useState(boolean);
  const [memberId, setMemberId] = useState(null);

  const statuses = [
    "All",
    "Order Placed",
    "Confirmed",
    "Processing",
    "Rejected",
    "Shipped",
    "Delivered",
    "Cancelled",
  ];

  useEffect(() => {
    if (isLoggedIn) {
      const storedCustomer = localStorage.getItem("customer");
      if (!storedCustomer) return;

      const customerObj = JSON.parse(storedCustomer);
      const id = customerObj?.ramNamBookMemberID || null;

      setMemberId(id);
      getActiveMemberTypeDDLData(id); // ✅ pass directly
    }
  }, []);

  function getActiveMemberTypeDDLData(id) {
    getOrder_GetAll_FilterList(0, 0, id, 0, "", "", "", "", 0)
      .then((response) => {
        let responseData = response.data.responseObject;
        console.log(responseData);

        if (response.data.isSuccess == true) {
          setOrderData(responseData);
          setIsLoggedIn(false);
        } else {
          toast.error(`${response.data.message}`);
          setOrderData([]);
        }
      })
      .catch((error) => {
        toast.error(`${error}`);
        setOrderData([]);
      });
  }

  const [showModal, setShowModal] = useState(false);
  const [orderDetails, setOrderDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  function handleViewOrder(orderID) {
    setLoading(true);
    GetProductList_ByOrderIDAPI(orderID)
      .then((res) => {
        if (res.data.isSuccess) {
          setOrderDetails(res.data.responseObject || []);
          setShowModal(true);
        } else {
          toast.error(res.data.message);
        }
      })
      .catch(() => {
        toast.error("Error fetching order details");
      })
      .finally(() => setLoading(false));
  }

  const filtered = orderData.filter((o) => {
    const matchSearch =
      o.orderNo.toLowerCase().includes(search.toLowerCase()) ||
      o.addressLine1.toLowerCase().includes(search.toLowerCase()) ||
      o.addressLine2.toLowerCase().includes(search.toLowerCase()) ||
      o.customerName.toLowerCase().includes(search.toLowerCase());
    const matchStatus = filterStatus === "All" || o.statusName === filterStatus;
    return matchSearch && matchStatus;
  });

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10; // change as needed
  const totalRecords = filtered.length;
  const totalPages = Math.ceil(totalRecords / recordsPerPage);

  const indexOfLast = currentPage * recordsPerPage;
  const indexOfFirst = indexOfLast - recordsPerPage;

  const currentRecords = filtered.slice(indexOfFirst, indexOfLast);
  const nextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const prevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };

  const goToPage = (page) => {
    setCurrentPage(page);
  };

  return (
    <>
      <MemberHeader MemberHeader />
      <div className="container-fluid py-4 bg-light min-vh-100">
        {/* Header */}
        <div className="d-flex justify-content-between align-items-center flex-wrap mb-3">
          <h6 className="fw-bold mb-2">
            Order <span className="text-danger">History</span>
          </h6>
          {/* Search */}
          <div className="input-group w-auto">
            <span className="input-group-text bg-white">
              <i className="bi bi-search"></i>
            </span>
            <input
              type="text"
              className="form-control"
              placeholder="Search orders..."
              value={search}
              onChange={(e) => setSearch(e.target.value)} // ✅ important
            />
          </div>
          {/* <div className="d-flex flex-wrap gap-2">
            {statuses.map((s) => (
              <button
                key={s}
                className={`btn btn-sm rounded-pill px-3 ${
                  filterStatus === s ? "btn-danger" : "btn-outline-secondary"
                }`}
                onClick={() => setFilterStatus(s)}
              >
                {s}
              </button>
            ))}
          </div> */}
          <div></div>
          <div className="input-group w-auto">
            <Badge className="cursor-pointer">
              <Link
                className="mb-2"
                onClick={() => navigate("/member/dashboard")}
              >
                ← Back to Dashboard
              </Link>
            </Badge>
          </div>
        </div>

        {/* Card */}
        <div className="card shadow-sm border-0 rounded-3">
          <div className="table-responsive">
            <table className="table align-middle mb-0 table-hover">
              <thead className="table-light">
                <tr className="text-uppercase small text-muted">
                  <th>Order No</th>
                  <th>Date</th>
                  <th>Customer</th>
                  <th>Address</th>
                  <th>Items</th>
                  <th>Status</th>
                  <th className="text-center">View</th>
                </tr>
              </thead>

              <tbody>
                {filtered.length === 0 ? (
                  <tr>
                    <td colSpan="7" className="text-center py-5 text-muted">
                      📭 No orders found
                    </td>
                  </tr>
                ) : (
                  currentRecords.map((order) => {
                    const sc =
                      statusConfig[order.status] || statusConfig.Processing;
                    return (
                      <tr key={order.orderID}>
                        <td className="text-truncate md">{order.orderNo}</td>

                        <td className="text-truncate md">{order.orderDate}</td>

                        <td className="text-truncate md">
                          {order.customerName}
                        </td>

                        <td
                          className="text-truncate md"
                          title={order.addressLine2 + " " + order.addressLine1}
                        >
                          {order.addressLine2 + " " + order.addressLine1}
                        </td>

                        <td className="text-truncate md">
                          {order.noOfItems} item
                          {order.noOfItems !== 1 ? "s" : ""}
                        </td>

                        <td>
                          <span
                            className="badge rounded-pill px-3 py-2"
                            style={{
                              background: sc.bg,
                              color: sc.color,
                            }}
                          >
                            {order.statusName || "N.A"}
                          </span>
                        </td>

                        <td className="text-center">
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => handleViewOrder(order.orderID)}
                          >
                            <i className="bi bi-eye"></i>
                          </button>
                        </td>
                      </tr>
                    );
                  })
                )}
              </tbody>
            </table>
          </div>

          {/* Footer */}
          <div className="card-footer d-flex justify-content-between align-items-center flex-wrap small text-muted">
            <span>
              Showing {indexOfFirst + 1} to{" "}
              {Math.min(indexOfLast, totalRecords)} of {totalRecords} orders
            </span>

            <div>
              {/* Previous */}
              <button
                className="btn btn-sm btn-light me-1"
                onClick={prevPage}
                disabled={currentPage === 1}
              >
                ←
              </button>

              {/* Page Numbers */}
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  className={`btn btn-sm me-1 ${
                    currentPage === i + 1 ? "btn-danger" : "btn-light"
                  }`}
                  onClick={() => goToPage(i + 1)}
                >
                  {i + 1}
                </button>
              ))}

              {/* Next */}
              <button
                className="btn btn-sm btn-light"
                onClick={nextPage}
                disabled={currentPage === totalPages}
              >
                →
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={() => setShowModal(false)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-[#FF4F00]">Order Details</Modal.Title>
        </Modal.Header>

        <Modal.Body className="p-0">
          <div className="table-responsive">
            <table className="table table-striped align-middle mb-0">
              <thead className="table-light">
                <tr className="text-center text-uppercase small">
                  <th>Sr no.</th>
                  <th className="text-start">Product</th>
                  <th>Category</th>
                  <th>Qty</th>
                  <th>Rate</th>
                  <th>Total</th>
                </tr>
              </thead>

              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="6" className="text-center py-5">
                      <div className="spinner-border text-danger"></div>
                    </td>
                  </tr>
                ) : orderDetails.length > 0 ? (
                  orderDetails.map((item, index) => (
                    <tr key={item.orderDetailID}>
                      <td className="text-center">{index + 1}</td>

                      <td>{item.productName}</td>

                      <td className="text-center">
                        {item.productCategoryName}
                      </td>

                      <td className="text-center">{item.qty}</td>

                      <td className="text-center">
                        ₹ {Number(item.rateOnOrder).toFixed(2)}
                      </td>

                      <td className="text-center fw-bold">
                        ₹ {Number(item.lineTotal).toFixed(2)}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center py-5 text-muted">
                      No data available
                    </td>
                  </tr>
                )}
              </tbody>

              {/* Footer */}
              {!loading && orderDetails.length > 0 && (
                <tfoot>
                  <tr className="fw-bold">
                    <td colSpan="5" className="text-end">
                      Grand Total
                    </td>
                    <td className="text-center text-success">
                      ₹{" "}
                      {orderDetails
                        .reduce((sum, i) => sum + Number(i.lineTotal || 0), 0)
                        .toFixed(2)}
                    </td>
                  </tr>
                </tfoot>
              )}
            </table>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
